import { Fragment } from "react";

export default function HighlightedText({ text, query = "" }) {
  const value = String(text ?? "");
  const keyword = query.trim();
  if (!keyword) return value;

  // Escape the query so punctuation is matched literally.
  const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = value.split(new RegExp(`(${escaped})`, "gi"));

  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <mark
        key={index}
        style={{ backgroundColor: "#ffe08a", color: "#1b2e24", borderRadius: 3 }}
      >
        {part}
      </mark>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  );
}
